<template>
  <transition name="el-zoom-in-center">
    <el-card class="box-card" style="text-align: left;" v-show="add.addshow">
      <el-steps :active="active" align-center>
        <el-step title="填写基本信息"></el-step>
        <el-step title="填写具体奖项"></el-step>
      </el-steps>
      <el-divider></el-divider>
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>配置规则</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <div v-show="show">
        <el-form ref="form" :model="form" label-width="110px" style="width:100%;" :rules="rules">
          <el-row>
            <el-col :span="8" :offset="8">
              <el-form-item label="模板">
                <el-popover placement="right" width="400" trigger="click" v-model="visible">
                  <el-table :data="tableData" highlight-current-row>
                    <el-table-column
                      width="100"
                      property="luckydrawRuleName"
                      show-overflow-tooltip
                      label="规则名称"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      property="awardObjectTypename"
                      show-overflow-tooltip
                      label="奖励对象"
                    ></el-table-column>
                    <el-table-column
                      width="100"
                      property="luckydrawChanceTypename"
                      show-overflow-tooltip
                      label="规则类型"
                    ></el-table-column>
                    <el-table-column label="操作" min-width="80" show-overflow-tooltip fixed="right">
                      <template slot-scope="tableData">
                        <el-button-group>
                          <el-button
                            type="primary"
                            @click="gettabledata(tableData.row),visible=false"
                          >选择</el-button>
                        </el-button-group>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button slot="reference" type="success">选择模板</el-button>
                </el-popover>
              </el-form-item>
              <el-form-item label="政策名称" prop="luckydrawActivityName">
                <el-input v-model.trim="form.luckydrawActivityName" style="width:80%"></el-input>
              </el-form-item>
              <el-form-item label="模板名称" prop="luckydrawRuleName">
                <el-input v-model.trim="form.luckydrawRuleName" style="width:80%"></el-input>
              </el-form-item>
              <el-form-item label="奖励对象" prop="awardObjectType">
                <el-select v-model.trim="form.awardObjectType" placeholder="请选择" style="width:80%">
                  <el-option
                    v-for="item in awardObjectType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="规则类型" prop="luckydrawChanceType">
                <el-select
                  v-model="form.luckydrawChanceType"
                  placeholder="请选择"
                  @change="luckydrawChanceTypechange($event)"
                  style="width:80%"
                >
                  <el-option
                    v-for="item in luckydrawChanceType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="活动时间" prop="datelist">
                <el-date-picker
                  style="width:100%"
                  v-model="form.datelist"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="备注" prop="awardRemark">
                <el-input type="textarea" v-model="form.awardRemark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="next('form')" type="primary">下一步</el-button>
        </div>
      </div>
      <div v-show="!show">
        <!-- 填写具体奖项 -->
        <h4>规则记录</h4>
        <br />
        <el-row>
          <el-col :span="8">
            <el-card shadow="never">
              <el-form
                ref="ruleform"
                :model="ruleform"
                label-width="100px"
                style="width:80%"
                :rules="rules"
              >
                <el-form-item label="奖项标题" prop="awardLevelName">
                  <el-input v-model.trim="ruleform.awardLevelName" style="width:100%"></el-input>
                </el-form-item>
                <el-form-item label="奖励类型" prop="awardStuffType">
                  <el-select
                    :label-in-value="true"
                    v-model="ruleform.awardStuffType"
                    placeholder="请选择"
                    style="width:100%"
                    @change="awardStuffTypechange($event)"
                  >
                    <el-option
                      v-for="item in awardStuffTypelist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="awardlabel" prop="awardStuffUuid">
                  <el-select
                    v-model="ruleform.awardStuffUuid"
                    @change="awardStuffUuidchange($event)"
                    placeholder="请选择"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in awardStuffUuidlist"
                      :key="item.awardStuffUuid"
                      :label="item.awardStuffName"
                      :value="item.awardStuffUuid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="比例"
                  prop="luckydrawRate"
                  v-show="this.form.luckydrawChanceType == 0"
                >
                  <el-input
                    @input="ruleform.luckydrawCount=Math.floor((ruleform.luckydrawRate/100)*add.count)"
                    v-model.number="ruleform.luckydrawRate"
                    style="width:100%"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="可中奖数" prop="luckydrawCount">
                  <el-input
                    :disabled="form.luckydrawChanceType !== 1"
                    v-model.number="ruleform.luckydrawCount"
                    style="width:100%"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('ruleform')">重置</el-button>
                <el-button
                  style="margin-top: 12px;"
                  type="primary"
                  @click="productadd('ruleform')"
                >保存</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right"></el-button>
          </el-col>
          <el-col :span="14">
            <el-card shadow="never">
              <el-table :data="form.luckydrawRuleDetailApplies" stripe style="width: 100%">
                <el-table-column prop="awardLevelName" label="奖励标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="awardStuffTypename" label="奖励类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="luckydrawChanceTypename" label="规则类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="awardStuffName" label="奖励明细" show-overflow-tooltip></el-table-column>
                <el-table-column prop="luckydrawRate" label="比例" min-width="100"></el-table-column>
                <el-table-column prop="luckydrawCount" label="可中奖数" min-width="100"></el-table-column>
                <el-table-column prop="address" label="操作" width="160" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button type="primary" @click="editrow(scope.row,scope.$index)">编辑</el-button>
                      <el-button
                        type="danger"
                        @click.native.prevent="deleteRow(scope.$index, form.luckydrawRuleDetailApplies)"
                      >删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="next('form')" type="primary">上一步</el-button>
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>
<script>
import {
  luckydrawruleapplyadd,
  findlistbytypeandgroup,
  findlistbyobject,
  distributoraddInBatch
} from "@/api/market/marketing";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null,
          uuids: [],
          count: 0
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      createtype: true,
      tamp: null,
      tableData: [],
      visible: false,
      show: true,
      active: 1,
      awardObjectType: [
        {
          value: "3",
          label: "分销商"
        }
      ],
      luckydrawChanceType: [
        {
          value: 0,
          label: "按比例"
        },
        // {
        //   value: 1,
        //   label: "按箱"
        // }
      ],
      awardStuffTypelist: [
        {
          value: 0,
          label: "红包"
        },
        {
          value: 1,
          label: "积分"
        },
        {
          value: 2,
          label: "实物"
        },
        {
          value: 3,
          label: "优惠卷"
        }
      ],
      awardStuffUuidlist: [],
      form: {
        startDate: null,
        stopDate: null,
        luckydrawActivityName: null,
        isTemplate: false,
        luckydrawTotalSum: 0,
        luckydrawUsedSum: 0,
        awardRemark: null,
        awardObjectType: "3",
        packageLevel: 2,
        luckydrawChanceType: null,
        luckydrawChanceTypename: null,
        luckydrawRuleName: null,
        repeatTimes: -1,
        luckydrawRuleApplyState: 1,
        luckydrawRuleUuid: "",
        luckydrawRuleDetailApplies: [],
        datelist: []
      },
      awardlabel: "金额",
      ruleform: {
        //步骤1 表单
        awardLevelName: null,
        awardStuffType: null,
        awardStuffUuid: null,
        luckydrawRate: 0.0,
        awardStuffTypename: null,
        awardStuffName: null,
        totalCount: 0,
        luckydrawCount: 0
      },
      // 步骤2表格数据
      rules: {
        Remark: [
          { required: true, message: "请输入备注", trigger: "blur" }
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        awardObjectType: [
          { required: true, message: "请输入奖励对象", trigger: "blur" }
        ],
        luckydrawChanceType: [
          { required: true, message: "请输入奖励类型", trigger: "blur" }
        ],
        datelist: [
          { required: true, message: "请选择抽奖时间", trigger: "blur" }
        ],
        luckydrawRate: [
          { type: "number", message: "必须为整数值" },
          ,
          { validator: this.validateAcquaintance, trigger: "blur" }
        ],
        luckydrawCount: [  { type: "number", message: "必须为整数值" }, ],
        awardLevelName: [
          { required: true, message: "请输入奖项标题", trigger: "blur" }
        ],
        awardStuffType: [
          { required: true, message: "请选择奖励类型", trigger: "blur" }
        ],
        awardStuffUuid: [
          { required: true, message: "请选择奖品明细", trigger: "blur" }
        ],
        luckydrawActivityName: [
          { required: true, message: "请输入政策名称", trigger: "blur" }
        ]
      }
    };
  },

  mounted() {
    this.Tabledata();
  },
  methods: {
    // 验证
    validateAcquaintance(rule, value, callback) {
      if (value < 0 || value > 100) {
        callback(new Error("中奖比例必须在 0 至 100 %之间"));
      } else {
        callback();
      }
    },
    //     //请求表格数据
    Tabledata(obj) {
      findlistbyobject({ page: 1, rows: 10000, objectType: "3" }).then(
        response => {
          this.packdate(response.data.rows);
          this.tableData = response.data.rows;
          console.log(this.tableData);
        }
      );
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (Number(obj[i].awardObjectType)) {
          case 1:
            obj[i].awardObjectTypename = "消费者/一般厨师";
            break;
          case 2:
            obj[i].awardObjectTypename = "终端厨师长";
            break;
          case 3:
            obj[i].awardObjectTypename = "分销商";
            break;
          case 4:
            obj[i].awardObjectTypename = "经销商";
            break;
          case 5:
            obj[i].awardObjectTypename = "企业用户";
            break;
          default:
            break;
        }
        switch (obj[i].luckydrawChanceType) {
          case 0:
            obj[i].luckydrawChanceTypename = "按比例";
            break;
          case 1:
            obj[i].luckydrawChanceTypename = "按箱";
            break;
          default:
            break;
        }
      }
    },
    // 选取模板
    gettabledata(row) {
        this.form = row; //  获取类型对应的name数据
        this.form.luckydrawRuleDetailApplies = row.luckydrawRuleDetails;
        for (let i = 0; i < this.form.luckydrawRuleDetailApplies.length; i++) {
          if (!this.form.luckydrawRuleDetailApplies[i].luckydrawChanceType) {
            this.form.luckydrawRuleDetailApplies[i].luckydrawCount = Math.floor(
              this.add.count *
                this.form.luckydrawRuleDetailApplies[i].luckydrawRate
            );
          }
          this.form.luckydrawRuleDetailApplies[
            i
          ].luckydrawChanceTypename = this.luckydrawChanceTypechange(
            this.form.luckydrawRuleDetailApplies[i].luckydrawChanceType
          );
          this.form.luckydrawRuleDetailApplies[
            i
          ].awardStuffTypename = this.awardStuffTypechange(
            this.form.luckydrawRuleDetailApplies[i].awardStuffType
          );
        }
    },
    // 奖品类型选中后
    awardStuffTypechange(e) {
      var obj = {};
      findlistbytypeandgroup({
        page: 1,
        rows: 1000,
        awardType: e
      }).then(response => {
        // 获取奖励明细下拉
        this.awardStuffUuidlist = response.data.rows;
      });
      obj = this.awardStuffTypelist.find(item => {
        //这里的userList就是上面遍历的数据源
        return item.value === e; //筛选出匹配数据
      });
      this.ruleform.awardStuffTypename = obj.label;
      this.ruleform.awardStuffUuid = null;
      // 下拉label显示
      switch (this.ruleform.awardStuffType) {
        case 0:
          this.awardlabel = "金额";
          break;
        case 1:
          this.awardlabel = "积分";
          break;
        case 2:
          this.awardlabel = "实物";
          break;
        case 3:
          this.awardlabel = "优惠卷";
          break;
        default:
          break;
      }
      return obj.label;
    },
    // 奖品明细选中后
    awardStuffUuidchange(e) {
      let obj = {};
      obj = this.awardStuffUuidlist.find(item => {
        return item.awardStuffUuid === e; //筛选出匹配数据
      });
      this.ruleform.awardStuffName = obj.awardStuffName;
      return obj.awardStuffName;
    },
    // 规则类型选中后
    luckydrawChanceTypechange(e) {
      let obj = {};
      obj = this.luckydrawChanceType.find(item => {
        return item.value === e; //筛选出匹配数据
      });
      this.form.luckydrawChanceTypename = obj.label;
      return obj.label;
    },
    // 步骤条
    next(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.show = !this.show;
          if (this.active++ >= 2) {
            this.active = 1;
          }
        } else {
          return false;
        }
      });
    },
    // 编辑明细表格
    editrow(row, index) {
      this.awardStuffTypechange(row.awardStuffType);
      setTimeout(() => {
        this.ruleform = Object.assign(this.ruleform, row); // 深拷贝
        if (!this.ruleform.luckydrawChanceType) {
          // 算出中奖盒数
          this.ruleform.luckydrawCount = Math.floor(
            this.add.count * this.ruleform.luckydrawRate
          );
        }
        this.createtype = false;
        this.tamp = index; // index指当前行下标
        if (this.ruleform.luckydrawRate < 1.01) {
          this.ruleform.luckydrawRate = Math.floor(
            this.ruleform.luckydrawRate * 100
          );
        }
        console.log(this.ruleform);
      }, 200);
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.createtype) {
            // 判断是修改还是新增
            // 新增编辑保存
            const obj = {};
            obj["awardLevelName"] = this.ruleform.awardLevelName;
            obj["awardStuffType"] = this.ruleform.awardStuffType;
            obj["awardStuffTypename"] = this.ruleform.awardStuffTypename;
            obj["awardStuffUuid"] = this.ruleform.awardStuffUuid;
            obj["awardStuffName"] = this.ruleform.awardStuffName;
            obj["luckydrawRate"] = this.ruleform.luckydrawRate / 100;
            obj["luckydrawCount"] = this.ruleform.luckydrawCount;
            obj["totalCount"] = this.ruleform.totalCount;
            obj["luckydrawChanceType"] = this.form.luckydrawChanceType;
            obj["luckydrawChanceTypename"] = this.form.luckydrawChanceTypename;
            obj["isTemplate"] = false;
            obj["luckydrawRuleDetailApplyUuid"] = "";
            obj["luckydrawRuleDetailUuid"] = "";
            obj["luckydrawRuleUuid"] = this.form.luckydrawRuleUuid || "";
            obj["awardNumber"] = 1;
            if (!obj.luckydrawChanceType) {
              // 算出中奖盒数
              obj.luckydrawCount = Math.floor(
                this.add.count * obj.luckydrawRate
              );
            }
            this.form.luckydrawRuleDetailApplies.push(obj);
            this.$refs[formName].resetFields();
          } else {
            // 修改编辑保存
            this.createtype = true;
            this.ruleform.luckydrawRate = this.ruleform.luckydrawRate / 100; // 先算比例
            if (!this.ruleform.luckydrawChanceType) {
              // 用比例算出中奖盒数
              this.ruleform.luckydrawCount = Math.floor(
                this.add.count * this.ruleform.luckydrawRate
              );
            }
            this.form.luckydrawRuleDetailApplies[this.tamp] = Object.assign(
              this.form.luckydrawRuleDetailApplies[this.tamp],
              this.ruleform
            ); // 深拷贝修改表格
            this.$refs[formName].resetFields();
          }
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          console.log(this.add.uuids);
          this.form.startDate = this.form.datelist[0] || null;
          this.form.stopDate = this.form.datelist[1] || null;
          this.form.luckydrawRuleApplyName = "default";
          this.form.repeatTimes = -1;
          this.form.luckydrawRuleApplyState = 1;
          // 判断累计明细中奖比例
          let tamp = 0;
          for (
            let i = 0;
            i < this.form.luckydrawRuleDetailApplies.length;
            i++
          ) {
            tamp =
              tamp + this.form.luckydrawRuleDetailApplies[i].luckydrawCount;
          }
          if (tamp > Math.floor(this.add.count * 1.5)) {
            this.$message({
              type: "warning",
              message: "明细中奖个数累计不能超过1.5倍出库个数"
            });
          } else {
            luckydrawruleapplyadd(this.form).then(response => {
              distributoraddInBatch({
                luckydrawRuleApplyUuid: response.data[0],
                packageLevel: this.form.packageLevel,
                outBillUuids: this.add.uuids
              }).then(response => {
                this.add.uuids = [];
                if (response.status_code == 200) {
                  // 配置成功后
                  this.$message({
                    type: "success",
                    message: "添加规则并配置成功!"
                  });
                  this.form.luckydrawRuleDetailApplies = []; //明细清空
                  this.add.addshow = false; // 关闭弹窗
                  this.next("form"); //  返回上一步
                  this.resetForm("form"); // 重置表单
                  this.search(); //  查询表格
                } else {
                }
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
